import { SHOW_MODAL, HIDE_MODAL } from '../types';

export const showModal = (modalType, instance) => ({
  type: SHOW_MODAL,
  modalType,
  instance,
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});
